import React from "react";

const BlackButton = ({ btnName, onClickBtn }) => {
  return (
    <button
      style={{
        backgroundColor: "black",
        color: "white",
        padding: "10px 20px",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
      }}
      onClick={onClickBtn}
    >
      {btnName}
    </button>
  );
};

export default BlackButton;
